import type { RegistrationChangeReason } from '../types/vehicleRegistration.types';

export const REGISTRATION_CHANGE_REASON_LABEL: Record<RegistrationChangeReason, string> = {
    to_private_plate: 'Private plate fitted',
    to_original_plate: 'Reverted to original plate',
    correction: 'Data correction',
};

/** An unknown value renders verbatim rather than blank, so a type this build has never
 *  seen is still legible. */
export const labelForReason = (reason: string | null): string | undefined =>
    reason === null
        ? undefined
        : (REGISTRATION_CHANGE_REASON_LABEL[reason as RegistrationChangeReason] ?? reason);
